import { ViewScopeEnum } from "../enums";
import { useHasPermissions } from "./use-has-permissions";

export const useViewScopePermission = (): {
  scopeOptions: ViewScopeEnum[];
  isSaveButtonDisabled: boolean;
} => {
  const { hasPermissions: hasCreateUserViewPermissions } = useHasPermissions({
    entity: "view",
    action: "create_user_view",
  });
  const { hasPermissions: hasCreateCompanyViewPermissions } = useHasPermissions(
    {
      entity: "view",
      action: "create_company_view",
    },
  );
  const { hasPermissions: hasCreateGlobalViewPermissions } = useHasPermissions({
    entity: "view",
    action: "create_global_view",
  });

  const isSaveButtonDisabled =
    !hasCreateUserViewPermissions &&
    !hasCreateCompanyViewPermissions &&
    !hasCreateGlobalViewPermissions;
  const allowedScopes = {
    [ViewScopeEnum.USER]: hasCreateUserViewPermissions,
    [ViewScopeEnum.COMPANY]: hasCreateCompanyViewPermissions,
    [ViewScopeEnum.GLOBAL]: hasCreateGlobalViewPermissions,
  };
  const scopeOptions: ViewScopeEnum[] = Object.entries(allowedScopes)
    .filter(([scope, isAllowed]) => isAllowed)
    .map(([scope, isAllowed]) => scope as ViewScopeEnum);

  return { scopeOptions, isSaveButtonDisabled };
};
